module.exports = __webpack_public_path__ + "media/dark-mode.ce7cca57.mp4";